import type { MessageDescriptor } from "react-intl";

import type { ViewClass } from "./types";

/**
 * The 8 protocol views in display order, each mapped to the EXISTING i18n id the
 * legacy slot labels already use (app/locale/{ru,en}.ts) — so the new UI and the
 * fallback speak the same words and we add no duplicate copy.
 */
export const VIEW_ORDER: readonly ViewClass[] = [
  "profile",
  "full_face_with_smile",
  "full_face_without_smile",
  "front_view",
  "occlusal_view_upper",
  "occlusal_view_lower",
  "lateral_view_right",
  "lateral_view_left",
];

export const VIEW_LABEL_ID: Record<ViewClass, MessageDescriptor["id"]> = {
  profile: "PHOTO_PROFILE",
  full_face_with_smile: "PHOTO_SMILE",
  full_face_without_smile: "PHOTO_PORTRATE",
  occlusal_view_upper: "PHOTO_UPPER_OCCLUSAL",
  occlusal_view_lower: "PHOTO_LOWER_OCCLUSAL",
  lateral_view_right: "PHOTO_RIGHT",
  front_view: "PHOTO_FRONT",
  lateral_view_left: "PHOTO_LEFT",
};
